'use client';

import Modal from './Modal';
import { useState } from 'react';
import Appointment from './Appointment';
import { Instrument } from '@/app/instruments';
import { capture } from '@/config/captureUserEvent';
import { EventNames } from '@/config/eventNames';

type MusicalPopupProps = {
  children: React.ReactNode;
  instrument?: Instrument;
  autoFocus?: boolean;
  /** Which button opened the booking, e.g. "hero", so taps can be told apart in PostHog. */
  placement?: string;
};

/**
 * Renders a booking popup modal.
 *
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The content to be rendered inside the component.
 * @returns {JSX.Element} The rendered MusiCalPopup component.
 */
export function MusiCalPopup({
  children,
  instrument,
  autoFocus = true,
  placement,
}: MusicalPopupProps) {
  const [open, setOpen] = useState(false);

  const onClickModal = () => {
    capture(EventNames.freeTrialBookCtaClicked, { instrument, placement });
    setOpen(true);
  };

  return (
    <>
      <Modal
        title={<>Free Trial Lesson Booking</>}
        onClose={setOpen}
        open={open}
      >
        <Appointment
          onClose={() => setOpen(false)}
          autoFocus={autoFocus}
          instrument={instrument}
        ></Appointment>
      </Modal>

      <span className="cursor-pointer" onClick={onClickModal}>
        {children}
      </span>
    </>
  );
}
